import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../__config/config.service';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  // FILE UPLOADS
  files: { [key: string]: File } = {};

  constructor(private http: HttpClient,private configService: ConfigService) { }

  getFiles(clientId: string, folder: string): Observable<any> {
    return this.http.get(`${this.configService.getApiUrlRefactor('appBase')}fileManager/list_files.php?clientId=${clientId}&folder=${folder}`);
  }

  getLocalSavedFiles(){
    return this.files;
  }

  uploadFile(clientId: string, folder: string, file: File): Observable<any> {
      const formData = new FormData();
      formData.append('clientId', clientId);
      formData.append('folder', folder);
      formData.append('file', file);
      return this.http.post(`${this.configService.getApiUrlRefactor('appBase')}fileManager/upload.php`, formData);

      /* const formData = new FormData();
      formData.append('contract_id', contractId.toString());
      formData.append('description', 'Pasaporte escaneado');
      formData.append('file', fileInput.files[0]);

      this.http.post('/api/upload_document.php', formData).subscribe(res => {
        console.log(res);
      }); */
  }

  validateDocsAreAttached(docs){
    let res = true;
    for(let doc of docs){
      if(!this.files[doc.file_id]){
        res = false;
      }
    }
    return res;
  }

  saveFileInLocal(event){
    this.files[event.fileId] = event.file;
  }

  isFileUploaded(fileLabel){
    return this.files[fileLabel];
  }

  uploadDocuments(filesMap: any, documentsToUpload: any[], processStatus: any, omnibusContractId: any): Promise<any[]> {
    const filesToUpload = documentsToUpload
      .map(doc => {
        const file = filesMap[doc.file_id];
        return file ? { ...doc, file } : null;
      })
      .filter(doc => doc !== null);

    const uploadPromises = filesToUpload.map(doc => {
      const formData = this.generateUploadFormData(doc, processStatus, omnibusContractId);
      return this.http
        .post(this.configService.getApiUrlRefactor('appBase')+`fileManager/upload_document.php?queryParam1=${processStatus}`, formData)
        .toPromise()
        .then(res => ({ status: 'fulfilled', file_id: doc.file_id, response: res }))
        .catch(err => ({ status: 'rejected', file_id: doc.file_id, error: err }));
    });

    return Promise.all(uploadPromises);
  }

  generateUploadFormData(fileObj: any, processStatus: number, omnibusContractId: number): FormData {
    const formData = new FormData();

    switch (processStatus) {
      case 3: // Passport and acceptance
      case 6: // ASISA Docs
        formData.append('description', fileObj.description);
        formData.append('FK_ID_omnibusContract', omnibusContractId.toString());
        formData.append('file', fileObj.file);
        formData.append('file_id', fileObj.file_id);
        break;
      default:
        break;
    }

    return formData;
  }

  getDocLabelById(fileId: string): string {
    const labels = {
      'cuestionario': 'Cuestionario de salud',
      'formulario': 'Formulario ASISA'
    };
    return labels[fileId] || fileId;
  }
}
